import { useLocation } from 'react-router-dom';
import { styled } from '@mui/material/styles';
import { Box } from '@mui/material';
import Typography from '@mui/material/Typography';
import { Stack } from '@mui/material';

import img_noData from '../../assets/images/img_noData.svg';
import img_noMatchData from '../../assets/images/img_noMatchData.svg';
import theme from '../../theme';

const ImgBlock = styled('img')(({ theme }) => ({
  maxWidth: '400px',
  marginBottom: '24px'
}))


const NoData = ({ searchKeyword, children }) => {
  const { pathname, state } = useLocation();

  if (searchKeyword !== '' && searchKeyword) {
    return (
      <Box
        sx={{
          width: '100%',
          padding: '64px 0',
          textAlign: 'center'
        }}
      >
        <ImgBlock src={img_noMatchData} alt="沒有符合條件的資料" />
        <Typography
          align="center"
        >
          沒有符合搜尋字詞
          <span
            style={{
              color: theme.palette.primary.main
            }}
          > {searchKeyword} </span>的結果
          <br />
          請檢查有無錯別字或試試其他關鍵字。
        </Typography>
      </Box>
    )
  }

  return (
    <>
      {
        <Box
          sx={{
            width: '100%',
            padding: '42px 0',
            textAlign: 'center',
          }}
        >
          <ImgBlock src={img_noData} alt="無資料" />
          {
            children
              ? children
              : <Typography>無資料</Typography>
          }
        </Box>
      }
    </>
  );
};

export default NoData;